import { actionTypes, mutationTypes, getterTypes } from "./types";
import _service from "../api";

const actions = {
  async [actionTypes.FETCH_SCHOOLS]({ commit }, id) {
    let data = [];

    if (id) {
      data = await _service.getSchoolsByType(id);
    } else {
      data = await _service.getSchools();
    }

    if (data) {
      commit(mutationTypes.SET_SCHOOLS, data.data);
    }
  },
  async [actionTypes.FETCH_SCHOOL_TYPES]({ commit, getters }) {
    if (getters[getterTypes.GET_SCHOOL_TYPES].length == 0) {
      const { data } = await _service.getSchoolTypes();
      if (data) {
        commit(mutationTypes.SET_SCHOOL_TYPES, data);
      }
    }
  },
  async [actionTypes.FETCH_MUNICIPALITIES]({ commit, getters }) {
    if (getters[getterTypes.GET_MUNICIPALITIES].length == 0) {
      const { data } = await _service.getMunicipalities();
      if (data) {
        commit(mutationTypes.SET_MUNICIPALITIES, data);
      }
    }
  },
  async [actionTypes.FETCH_RLVTYPES]({ commit, getters }) {
    if (getters[getterTypes.GET_RLVTYPES].length == 0) {
      const { data } = await _service.getRLVClassificationTypes();
      if (data) {
        commit(mutationTypes.SET_RLVTYPES, data);
      }
    }
  },
  async [actionTypes.FETCH_SCHOOL_BY_ID](_, { id }) {
    const { data } = await _service.getSchoolById(id);
    return data;
  },
  async [actionTypes.FETCH_RESULTS]({ commit }, filters) {
    const { data } = await _service.getSchoolResults(filters);
    if (data) {
      commit(mutationTypes.SET_RESULTS, data);
    }
  },
  async [actionTypes.SAVE_CHANGES](_, { formData, isEditMode }) {
    if (isEditMode) {
      return await _service.updateSchool(formData);
    } else {
      return await _service.saveSchool(formData);
    }
  }
};

export default actions;
